import { createApp as _createApp } from "vue";

import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import vClickOutside from "click-outside-vue3";
import IMask from "imask";

import { CentrifugoApi } from "@js-app/office/api/centrifugo-api";
import { Centrifuge } from "centrifuge";

const env = import.meta.env

export async function subscribeToWssChannels(store, action, channel) {
  await store.dispatch(action, channel);
}

export async function getWssToken() {
  return new Promise((resolve, reject) => {
    CentrifugoApi.getAccessToken()
        .then((r) => resolve(r.data.token))
        .catch((err) => reject(err));
  });
}

export async function initWssConnection(
    store,
    action,
    afterConnectCallback = async () => {}
) {
  const tokenResponse = await CentrifugoApi.getAccessToken();

  const wss = new Centrifuge(env.VITE_WSS_URL, {
    token: tokenResponse.data.token,
    getToken: () => getWssToken(),
  });

  wss.on("connected", async () => {
    await store.dispatch(action, wss);
    await afterConnectCallback();
  });

  wss.connect();
}

export async function initializeBaseVuePluginsAndDirectives(app) {
  app.use(FloatingVue);
  app.use(vClickOutside);

  function toOptions(v) {
    if (v == null || v === false) return null;
    if (typeof v === "object" && (("mask" in v) || ("blocks" in v) || ("pattern" in v))) {
      return v;
    }
    return { mask: v };
  }

  app.directive("mask", {
    mounted(el, binding) {
      const opts = toOptions(binding.value);
      if (!opts) return;
      el._imask = IMask(el, opts);
    },
    updated(el, binding) {
      const opts = toOptions(binding.value);
      if (!opts) {
        el._imask?.destroy();
        el._imask = null;
        return;
      }
      if (!el._imask) {
        el._imask = IMask(el, opts);
      } else {
        el._imask.updateOptions(opts);
      }
    },
    unmounted(el) {
      el._imask?.destroy();
      el._imask = null;
    },
  });
}

export async function injectVueGlobals(app, globalVariables = {}) {
  for (const key in globalVariables) {
    app.config.globalProperties[`$${key}`] = globalVariables[key];
  }
}

export async function createApp(
    RootComponent,
    {
      el = "#app",
      router,
      store,
      i18n,
      beforeAppCreated = async () => {},
      afterAppCreated = async () => {},
    } = {}
) {
  const app = _createApp(RootComponent);

  // Підключення плагінів ДО mount
  if (i18n) app.use(i18n);
  if (store) app.use(store);
  if (router) app.use(router);

  // Твої «хуки»
  await beforeAppCreated(app);
  await afterAppCreated(app);

  app.mount(el);
  return app;
}
